import { HttpClient } from '../shared/api/HttpClient';
import type { LiveMediaState, LiveSessionCredential } from '../shared/media/LiveMediaAdapter';

export interface GuestInvitationPreview {
  guestName: string;
  stationName: string;
  programName: string | null;
  validFrom: string;
  validUntil: string;
  state: 'WAITING';
}

export type GuestState = 'CONNECTED' | 'BACKSTAGE' | 'ON_AIR' | 'MUTED' | 'DISCONNECTED';

export interface GuestSession {
  participantId: string;
  liveSessionId: string;
  stationId: string;
  stationName: string;
  guestName: string;
  programName: string | null;
  state: GuestState;
  expiresAt: string;
  accessToken: string;
  heartbeatTtlSeconds: number;
  credential: LiveSessionCredential;
}

export class GuestApi {
  readonly #http = new HttpClient();

  public preview(invitationToken: string): Promise<GuestInvitationPreview> {
    return this.#post('/guest/connect/preview', { invitationToken });
  }

  public redeem(invitationToken: string): Promise<GuestSession> {
    return this.#post('/guest/connect/redeem', { invitationToken });
  }

  public heartbeat(accessToken: string, media: LiveMediaState): Promise<{ state: GuestState; routingGroup: 'backstage' | 'onair'; quality: string | null; heartbeatTtlSeconds: number }> {
    return this.#http.request('/guest/connect/heartbeat', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Guest ${accessToken}` },
      body: JSON.stringify({ quality: { latencyMs: media.latencyMs, jitterMs: media.jitterMs, packetLossPercent: media.packetLossPercent } }),
    });
  }

  #post<T>(path: string, body: Record<string, unknown>): Promise<T> {
    return this.#http.request(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }
}
